import {
  ControlProps,
  CSSObjectWithLabel,
  GroupBase,
  OptionProps,
  StylesConfig,
} from 'react-select'

export const reactSelectStyles = {
  control: (
    provided: CSSObjectWithLabel,
    props: ControlProps<
      {
        label: string
        value: string
      },
      false,
      GroupBase<{
        label: string
        value: string
      }>
    >,
  ) => {
    return {
      ...provided,
      backgroundColor: 'var(--bg-base)',
      color: 'var(--base-text)',
      cursor: 'text',
      borderRadius: 'var(--border-radius-m)',
      border: 'var(--border-width-thin) solid var(--tint-gray-300)',
      '&:hover': {
        borderColor: 'var(--tint-gray-300)',
      },
      borderColor: props.isFocused
        ? 'var(--color-primary)'
        : 'var(--tint-gray-300)',
      boxShadow: props.isFocused
        ? '0 0 0 1px var(--color-primary)'
        : provided.boxShadow,
    }
  },
  input: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: 'var(--base-text)',
  }),
  placeholder: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: 'var(--base-text)',
    fontSize: 'var(--text-size-m)',
    fontWeight: 'bold',
  }),
  singleValue: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: 'var(--tint-gray-800)',
    fontSize: 'var(--text-size-m)',
    fontWeight: 'bold',
  }),
  indicatorSeparator: (provided: CSSObjectWithLabel) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided: CSSObjectWithLabel) => ({
    ...provided,
    paddingLeft: '0px',
    color: 'var(--base-text)',
  }),
  clearIndicator: (provided: CSSObjectWithLabel) => ({
    ...provided,
    paddingRight: '0px',
    color: 'var(--base-text)',
  }),
  menu: (provided: CSSObjectWithLabel) => ({
    ...provided,
    color: 'var(--tint-gray-700)',
    backgroundColor: 'var(--base-bg)',
    borderRadius: 'var(--border-radius-m)',
    padding: '0 0.25rem',
    border: 'var(--border-width-thin) solid var(--color-grey-700)',
    zIndex: 9999,
  }),
  option: (
    provided: CSSObjectWithLabel,
    {
      isFocused,
      isSelected,
    }: OptionProps<
      {
        label: string
        value: string
      },
      false,
      GroupBase<{
        label: string
        value: string
      }>
    >,
  ) => ({
    ...provided,
    color: `var(--tint-gray-${isSelected ? '900' : '700'})`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.25rem',
    cursor: 'pointer',
    borderRadius: 'var(--border-radius-s)',
    wordBreak: 'break-all',
    backgroundColor:
      isSelected || isFocused ? 'var(--color-grey-050)' : 'var(--base-bg)',
    '&:hover': {
      backgroundColor: 'var(--color-grey-050)',
      color: 'var(--tint-gray-900)',
    },
  }),
} as StylesConfig<{ label: string; value: string }, false>

export const reactSelectMultiStyles = {
  ...reactSelectStyles,
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'transparent',
    border: 'var(--border-width-thin) solid var(--color-primary)',
    borderRadius: 9999,
    paddingRight: '0.75rem',
    paddingLeft: '0.75rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    fontSize: 'var(--text-size-m)',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'var(--color-primary)',
    fontSize: 'var(--text-size-m)',
    fontWeight: 600,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    cursor: 'pointer',
    color: 'var(--color-primary)',
    '&:hover': {
      backgroundColor: 'transparent',
      borderRadius: 'var(--border-radius-l)',
      color: 'var(--color-primary)',
    },
  }),
} as StylesConfig<{ label: string; value: string }, false>
